/* ============================================================
   BED BUILDER — CONFIG FILE
   This is the ONLY file you need to edit.
   Paste your Shopify image URLs and variant IDs below.
   ============================================================

   HOW TO GET IMAGE URLS:
   Shopify Admin → Content → Files → click the 🔗 icon

   HOW TO GET VARIANT IDs:
   Shopify Admin → Products → click a product → click a variant
   → the number at the end of the URL is the variant ID
   e.g. /variants/12345678901234  →  use  12345678901234

   ============================================================ */


/* ------------------------------------------------------------
   SECTION 0A — BED SIZES
   Edit labels and dimensions to match your actual products.
   ------------------------------------------------------------ */

window.BB_SIZES = {
  single: { label: 'Single', dimensions: 'Edit me' },
  queen:  { label: 'Queen',  dimensions: 'Edit me' },
  king:   { label: 'King',   dimensions: 'Edit me' },
}


/* ------------------------------------------------------------
   SECTION 0C — DISCOUNT SETTINGS
   Change these numbers any time — no other file needs editing.

   discountPerItemPercent → % added per item once threshold is hit
     e.g. 3 → bundle gets 3%, 6%, 9%, 12%... as items are added

   discountThreshold → minimum items needed before ANY discount
     e.g. 2 → no discount until 2nd item is added

   addonDiscounts → % off for each add-on item specifically
     (this is separate from the bundle discount above —
      it's the "ADD ON FOR X% OFF" badge shown on add-on rows)
   ------------------------------------------------------------ */

window.BB_DISCOUNT_SETTINGS = {
  discountPerItemPercent: 3,
  discountThreshold: 2,

  addonDiscounts: {
    bolstercase: 20,
    pillow_case: 20,
  },
}


/* ------------------------------------------------------------
   SECTION 0B — INSPIRED LOOKS CAROUSEL
   Add as many looks as you want.
   image: CDN URL of the look photo (upload to Content → Files)
   caption: text shown under photo e.g. colour combo name
   ------------------------------------------------------------ */

window.BB_INSPO_LOOKS = [
  { image: '', caption: 'Look 1 — edit caption here' },
  { image: '', caption: 'Look 2 — edit caption here' },
  { image: '', caption: 'Look 3 — edit caption here' },
]


/* ------------------------------------------------------------
   SECTION 1 — IMAGE URLS
   Paste the CDN URL for each image file you uploaded.
   ------------------------------------------------------------ */

window.BB_IMAGES = {

  // The base bed image (greyed out fitted sheet)
  base: 'https://cdn.shopify.com/s/files/1/0734/9596/9844/files/bb-layer-base.png?v=1777026149',

  // Grey default layers (always visible when item not selected)
  defaults: {
    pillowcase_pair: 'https://cdn.shopify.com/s/files/1/0734/9596/9844/files/bb-layer-pillowcase_pair-default.png?v=1777026149',
    duvet_cover:     'https://cdn.shopify.com/s/files/1/0734/9596/9844/files/bb-layer-duvet_cover-default.png?v=1777026150',
    bolstercase:     'https://cdn.shopify.com/s/files/1/0734/9596/9844/files/bb-layer-bolstercase-default.png?v=1777026148',
    pillow_case:     'https://cdn.shopify.com/s/files/1/0734/9596/9844/files/bb-layer-pillow_case-default.png?v=1777026149',
  },

  // Fitted Sheet
  fitted_sheet: {
    pyjama_stripes_oak:     'https://cdn.shopify.com/s/files/1/0734/9596/9844/files/bb-layer-fitted_sheet-pyjama_stripes_oak.png?v=1777026151',
    sleepover_stripes_blue: 'https://cdn.shopify.com/s/files/1/0734/9596/9844/files/bb-layer-fitted_sheet-sleepover_stripes_blue.png?v=1777026151',
    pyjama_stripes_forest:  'https://cdn.shopify.com/s/files/1/0734/9596/9844/files/bb-layer-fitted_sheet-pyjama_stripes_forest.png?v=1777026151',
    agnes_pink:             'https://cdn.shopify.com/s/files/1/0734/9596/9844/files/bb-layer-fitted_sheet-agnes_pink.png?v=1777026151',
    canvas_beige:           'https://cdn.shopify.com/s/files/1/0734/9596/9844/files/bb-layer-fitted_sheet-canvas_beige.png?v=1777026150',
    silver_blue:            'https://cdn.shopify.com/s/files/1/0734/9596/9844/files/bb-layer-fitted_sheet-silver_blue.png?v=1777026151',
    candy_stripes_pink:     '',  // future launch — leave blank for now
  },

  // Pillowcase Pair
  // ⚠️  pyjama_stripes_oak below is pointing to canvas_beige URL — check and replace
  pillowcase_pair: {
    pyjama_stripes_oak:     'https://cdn.shopify.com/s/files/1/0734/9596/9844/files/bb-layer-pillowcase_pair-pyjama_stripes_oak.png?v=1777026149',
    sleepover_stripes_blue: 'https://cdn.shopify.com/s/files/1/0734/9596/9844/files/bb-layer-pillowcase_pair-sleepover_stripes_blue.png?v=1777026149',
    pyjama_stripes_forest:  'https://cdn.shopify.com/s/files/1/0734/9596/9844/files/bb-layer-pillowcase_pair-pyjama_stripes_forest.png?v=1777026149',
    agnes_pink:             'https://cdn.shopify.com/s/files/1/0734/9596/9844/files/bb-layer-pillowcase_pair-agnes_pink.png?v=1777026149',
    canvas_beige:           'https://cdn.shopify.com/s/files/1/0734/9596/9844/files/bb-layer-pillowcase_pair-canvas_beige.png?v=1777026149',
    silver_blue:            'https://cdn.shopify.com/s/files/1/0734/9596/9844/files/bb-layer-pillowcase_pair-silver_blue.png?v=1777026150',
    candy_stripes_pink:     '',
  },

  // Duvet Cover
  duvet_cover: {
    pyjama_stripes_oak:     'https://cdn.shopify.com/s/files/1/0734/9596/9844/files/bb-layer-duvet_cover-pyjama_stripes_oak.png?v=1777026151',
    sleepover_stripes_blue: 'https://cdn.shopify.com/s/files/1/0734/9596/9844/files/bb-layer-duvet_cover-sleepover_stripes_blue.png?v=1777026151',
    pyjama_stripes_forest:  'https://cdn.shopify.com/s/files/1/0734/9596/9844/files/bb-layer-duvet_cover-pyjama_stripes_forest.png?v=1777026151',
    agnes_pink:             'https://cdn.shopify.com/s/files/1/0734/9596/9844/files/bb-layer-duvet_cover-agnes_pink.png?v=1777026150',
    canvas_beige:           'https://cdn.shopify.com/s/files/1/0734/9596/9844/files/bb-layer-duvet_cover-canvas_beige.png?v=1777026150',
    silver_blue:            'https://cdn.shopify.com/s/files/1/0734/9596/9844/files/bb-layer-duvet_cover-silver_blue.png?v=1777026150',
    candy_stripes_pink:     '',
  },

  // Bolstercase
  bolstercase: {
    pyjama_stripes_oak:     'https://cdn.shopify.com/s/files/1/0734/9596/9844/files/bb-layer-bolstercase-pyjama_stripes_oak.png?v=1777026149',
    sleepover_stripes_blue: 'https://cdn.shopify.com/s/files/1/0734/9596/9844/files/bb-layer-bolstercase-sleepover_stripes_blue.png?v=1777026149',
    pyjama_stripes_forest:  'https://cdn.shopify.com/s/files/1/0734/9596/9844/files/bb-layer-bolstercase-pyjama_stripes_forest.png?v=1777026149',
    agnes_pink:             'https://cdn.shopify.com/s/files/1/0734/9596/9844/files/bb-layer-bolstercase-agnes_pink.png?v=1777026149',
    canvas_beige:           'https://cdn.shopify.com/s/files/1/0734/9596/9844/files/bb-layer-bolstercase-canvas_beige.png?v=1777026149',
    silver_blue:            'https://cdn.shopify.com/s/files/1/0734/9596/9844/files/bb-layer-bolstercase-silver_blue.png?v=1777026149',
    candy_stripes_pink:     '',
  },

  // Pillow Case (add-on)
  pillow_case: {
    pyjama_stripes_oak:     'https://cdn.shopify.com/s/files/1/0734/9596/9844/files/bb-layer-pillow_case-pyjama_stripes_oak.png?v=1777026149',
    sleepover_stripes_blue: 'https://cdn.shopify.com/s/files/1/0734/9596/9844/files/bb-layer-pillow_case-sleepover_stripes_blue.png?v=1777026149',
    pyjama_stripes_forest:  'https://cdn.shopify.com/s/files/1/0734/9596/9844/files/bb-layer-pillow_case-pyjama_stripes_forest.png?v=1777026149',
    agnes_pink:             'https://cdn.shopify.com/s/files/1/0734/9596/9844/files/bb-layer-pillow_case-agnes_pink.png?v=1777026149',
    canvas_beige:           'https://cdn.shopify.com/s/files/1/0734/9596/9844/files/bb-layer-pillow_case-canvas_beige.png?v=1777026149',
    silver_blue:            'https://cdn.shopify.com/s/files/1/0734/9596/9844/files/bb-layer-pillow_case-silver_blue.png?v=1777026149',
    candy_stripes_pink:     '',
  },

}


/* ------------------------------------------------------------
   SECTION 1B — COLOUR SWATCH IMAGES
   Paste the URL of each colour's swatch icon image.
   These are the small circle thumbnails shown in the colour picker.
   Upload your swatch images to Content → Files and paste URLs here.
   If left blank, a solid colour circle will show instead.
   ------------------------------------------------------------ */

window.BB_SWATCH_IMAGES = {
  pyjama_stripes_oak:     'https://cdn.shopify.com/s/files/1/0734/9596/9844/files/3._Pajama_Stripe_In_Oak.png?v=1770949569',
  sleepover_stripes_blue: 'https://cdn.shopify.com/s/files/1/0734/9596/9844/files/1._Sleepover_Stripe_In_Blue.png?v=1770949569',
  pyjama_stripes_forest:  'https://cdn.shopify.com/s/files/1/0734/9596/9844/files/2._Pajama_Stripe_In_Forest.png?v=1770949569',
  agnes_pink:             'https://cdn.shopify.com/s/files/1/0734/9596/9844/files/6.Agnes_Pink.png?v=1770949569',
  canvas_beige:           'https://cdn.shopify.com/s/files/1/0734/9596/9844/files/4._Canvas_Beige.png?v=1770949569',
  silver_blue:            'https://cdn.shopify.com/s/files/1/0734/9596/9844/files/5.Silver_Blue.png?v=1770949569',
  candy_stripes_pink:     'https://cdn.shopify.com/s/files/1/0734/9596/9844/files/7._Candy_Stripe_In_Pink.png?v=1770949569',
}


/* ------------------------------------------------------------
   SECTION 1C — PRICING, STOCK & PREORDER
   Pulled directly from your live Shopify product prices/stock.
   Nested the same way as BB_VARIANTS: item → colour → size.

   price      → current selling price (number, no currency symbol)
   compareAt  → original price to show with a strike-through.
                Leave as '' if there's no discount.
   available  → true = in stock.
                false = out of stock. What happens next depends
                on the colour (see PREORDER_ALLOWED_COLOURS in
                bed-builder.js):
                  - if the colour is in that allow-list → shows
                    as PREORDER with the ship date text below
                  - any other colour → shows as SOLD OUT, swatch
                    is disabled/crossed-out and can't be selected
   shipDate   → only used for colours in the preorder allow-list.
                e.g. 'Shipping: End Aug 2026'

   Current preorder allow-list (edit PREORDER_ALLOWED_COLOURS in
   bed-builder.js to change): Pajama Stripes in Oak,
   Sleepover Stripes in Blue, Canvas Beige.
   Everything else marked available:false shows as SOLD OUT.

   ⚠️ Items below marked available:false are currently OUT OF
   STOCK in your store (0 inventory at the time this was pulled).

   pillowcase_pair and bolstercase have ONE price for all sizes
   (your store doesn't size these items).
   ------------------------------------------------------------ */

function price(amount, compareAt = '', available = true, shipDate = '') {
  return { price: amount, compareAt, available, shipDate }
}

window.BB_PRICING = {

  fitted_sheet: {
    pyjama_stripes_oak: {
      single: price(199),
      queen:  price(259),
      king:   price(279),
    },
    sleepover_stripes_blue: {
      single: price(199),
      queen:  price(259),
      king:   price(279),
    },
    pyjama_stripes_forest: {
      single: price(199),
      queen:  price(259),
      king:   price(279),
    },
    agnes_pink: {
      single: price(149),
      queen:  price(219),
      king:   price(239),
    },
    canvas_beige: {
      single: price(149),
      queen:  price(219),
      king:   price(239, '', false, 'Shipping: End Aug 2026'),  // ⚠️ out of stock
    },
    silver_blue: {
      single: price(149),
      queen:  price(219),
      king:   price(239),
    },
  },

  duvet_cover: {
    pyjama_stripes_oak: {
      single: price(299),
      queen:  price(339),
      king:   price(369, '', false, 'Shipping: End Aug 2026'),  // ⚠️ out of stock
    },
    sleepover_stripes_blue: {
      single: price(299),
      queen:  price(339),
      king:   price(369, '', false, 'Shipping: End Aug 2026'),  // ⚠️ out of stock
    },
    pyjama_stripes_forest: {
      single: price(299),
      queen:  price(339),
      king:   price(369),
    },
    agnes_pink: {
      single: price(249),
      queen:  price(289),
      king:   price(309),
    },
    canvas_beige: {
      single: price(249, '', false, 'Shipping: End Aug 2026'),  // ⚠️ out of stock
      queen:  price(289, '', false, 'Shipping: End Aug 2026'),  // ⚠️ out of stock
      king:   price(309, '', false, 'Shipping: End Aug 2026'),  // ⚠️ out of stock
    },
    silver_blue: {
      single: price(249),
      queen:  price(289),
      king:   price(309),
    },
  },

  // No size variants in your store — same price across single/queen/king
  pillowcase_pair: {
    pyjama_stripes_oak:     { single: price(119), queen: price(119), king: price(119) },
    sleepover_stripes_blue: { single: price(119), queen: price(119), king: price(119) },
    pyjama_stripes_forest:  { single: price(119, '', false), queen: price(119, '', false), king: price(119, '', false) }, // ⚠️ SOLD OUT — Forest isn't a preorder-eligible colour
    agnes_pink:             { single: price(95),  queen: price(95),  king: price(95)  },
    canvas_beige:           { single: price(95),  queen: price(95),  king: price(95)  },
    silver_blue:            { single: price(95),  queen: price(95),  king: price(95)  },
  },

  // Same product as Pillowcase Pair — using identical pricing
  pillow_case: {
    pyjama_stripes_oak:     { single: price(119), queen: price(119), king: price(119) },
    sleepover_stripes_blue: { single: price(119), queen: price(119), king: price(119) },
    pyjama_stripes_forest:  { single: price(119, '', false), queen: price(119, '', false), king: price(119, '', false) }, // ⚠️ SOLD OUT — Forest isn't a preorder-eligible colour
    agnes_pink:             { single: price(95),  queen: price(95),  king: price(95)  },
    canvas_beige:           { single: price(95),  queen: price(95),  king: price(95)  },
    silver_blue:            { single: price(95),  queen: price(95),  king: price(95)  },
  },

  // No size variants in your store — same price across single/queen/king
  bolstercase: {
    pyjama_stripes_oak:     { single: price(85), queen: price(85), king: price(85) },
    sleepover_stripes_blue: { single: price(85), queen: price(85), king: price(85) },
    pyjama_stripes_forest:  { single: price(85), queen: price(85), king: price(85) },
    agnes_pink:             { single: price(65), queen: price(65), king: price(65) },
    canvas_beige:           { single: price(65), queen: price(65), king: price(65) },
    silver_blue:            { single: price(65), queen: price(65), king: price(65) },
  },

}


/* ------------------------------------------------------------
   SECTION 2 — SHOPIFY VARIANT IDs
   Paste the variant ID for each item × size × colour combo.
   If a size is not available for a colour, leave it blank.
   ------------------------------------------------------------ */

window.BB_VARIANTS = {

  fitted_sheet: {
    pyjama_stripes_oak: {
      single_tencel: '47538219122740',
      queen_tencel:  '47538219155508',
      king_tencel:   '47538219188276',
    },
    sleepover_stripes_blue: {
      single_tencel: '47538255396916',
      queen_tencel:  '47538255429684',
      king_tencel:   '47538255462452',
    },
    pyjama_stripes_forest: {
      single_tencel: '47538218926132',
      queen_tencel:  '47538218958900',
      king_tencel:   '47538218991668',
    },
    agnes_pink: {
      single_tencel: '47538255560756',
      queen_tencel:  '47538255593524',
      king_tencel:   '47538255626292',
    },
    canvas_beige: {
      single_tencel: '47538256379956',
      queen_tencel:  '47538256412724',
      king_tencel:   '47538256445492',   // ⚠️ out of stock — see pricing notes
    },
    silver_blue: {
      single_tencel: '47538256609332',
      queen_tencel:  '47538256642100',
      king_tencel:   '47538256674868',
    },
    candy_stripes_pink: {   // future launch — leave blank for now
      single_tencel: '',
      queen_tencel:  '',
      king_tencel:   '',
    },
  },

  duvet_cover: {
    pyjama_stripes_oak: {
      single_tencel: '47547247460404',
      queen_tencel:  '47521577893940',
      king_tencel:   '47521577926708',   // ⚠️ out of stock
    },
    sleepover_stripes_blue: {
      single_tencel: '47547247427636',
      queen_tencel:  '47521599586356',
      king_tencel:   '47521599619124',   // ⚠️ out of stock
    },
    pyjama_stripes_forest: {
      single_tencel: '47547247591476',
      queen_tencel:  '47521520156724',
      king_tencel:   '47521520189492',
    },
    agnes_pink: {
      single_tencel: '47547248214068',
      queen_tencel:  '47521601749044',
      king_tencel:   '47521601781812',
    },
    canvas_beige: {
      single_tencel: '47547248312372',   // ⚠️ out of stock
      queen_tencel:  '47521602109492',   // ⚠️ out of stock
      king_tencel:   '47521602142260',   // ⚠️ out of stock
    },
    silver_blue: {
      single_tencel: '47547248082996',
      queen_tencel:  '47521600831540',
      king_tencel:   '47521600864308',
    },
    candy_stripes_pink: {
      single_tencel: '',
      queen_tencel:  '',
      king_tencel:   '',
    },
  },

  // Same Standard variant ID used for every size (no sizing on this product)
  pillowcase_pair: {
    pyjama_stripes_oak:     { single_tencel: '47539686178868', queen_tencel: '47539686178868', king_tencel: '47539686178868' },
    sleepover_stripes_blue: { single_tencel: '47539685818420', queen_tencel: '47539685818420', king_tencel: '47539685818420' },
    pyjama_stripes_forest:  { single_tencel: '47539687096372', queen_tencel: '47539687096372', king_tencel: '47539687096372' },  // ⚠️ out of stock
    agnes_pink:             { single_tencel: '47539673497652', queen_tencel: '47539673497652', king_tencel: '47539673497652' },
    canvas_beige:           { single_tencel: '47540087521332', queen_tencel: '47540087521332', king_tencel: '47540087521332' },
    silver_blue:            { single_tencel: '47539675824180', queen_tencel: '47539675824180', king_tencel: '47539675824180' },
    candy_stripes_pink:     { single_tencel: '', queen_tencel: '', king_tencel: '' },
  },

  // Same product/variants as Pillowcase Pair (you don't sell a separate single pillowcase)
  pillow_case: {
    pyjama_stripes_oak:     { single_tencel: '47539686178868', queen_tencel: '47539686178868', king_tencel: '47539686178868' },
    sleepover_stripes_blue: { single_tencel: '47539685818420', queen_tencel: '47539685818420', king_tencel: '47539685818420' },
    pyjama_stripes_forest:  { single_tencel: '47539687096372', queen_tencel: '47539687096372', king_tencel: '47539687096372' },  // ⚠️ out of stock
    agnes_pink:             { single_tencel: '47539673497652', queen_tencel: '47539673497652', king_tencel: '47539673497652' },
    canvas_beige:           { single_tencel: '47540087521332', queen_tencel: '47540087521332', king_tencel: '47540087521332' },
    silver_blue:            { single_tencel: '47539675824180', queen_tencel: '47539675824180', king_tencel: '47539675824180' },
    candy_stripes_pink:     { single_tencel: '', queen_tencel: '', king_tencel: '' },
  },

  // Same Default Title variant ID used for every size (no sizing on this product)
  bolstercase: {
    pyjama_stripes_oak:     { single_tencel: '47538332696628', queen_tencel: '47538332696628', king_tencel: '47538332696628' },
    sleepover_stripes_blue: { single_tencel: '47538342068276', queen_tencel: '47538342068276', king_tencel: '47538342068276' },
    pyjama_stripes_forest:  { single_tencel: '47538337054772', queen_tencel: '47538337054772', king_tencel: '47538337054772' },
    agnes_pink:             { single_tencel: '47538330894388', queen_tencel: '47538330894388', king_tencel: '47538330894388' },
    canvas_beige:           { single_tencel: '47538331942964', queen_tencel: '47538331942964', king_tencel: '47538331942964' },
    silver_blue:            { single_tencel: '47538257723444', queen_tencel: '47538257723444', king_tencel: '47538257723444' },
    candy_stripes_pink:     { single_tencel: '', queen_tencel: '', king_tencel: '' },
  },

}